export const RIGHTS = {
  // Appointments
  APPOINTMENTS_CREATE: 'appointments-create',
  APPOINTMENTS_CREATE_AS_PATIENT: 'appointments-create_as_patient',
  APPOINTMENTS_DELETE: 'appointments-delete',
  APPOINTMENTS_LIST: 'appointments-list',
  APPOINTMENTS_NAVIGATE: 'appointments-navigate',
  APPOINTMENTS_UPDATE: 'appointments-update',
  APPOINTMENTS_LOCATIONS: 'appointments-locations',

  // Availabilities
  AVAILABILITIES_CREATE: 'availabilities-create',
  AVAILABILITIES_DELETE: 'availabilities-delete',
  AVAILABILITIES_LIST: 'availabilities-list',
  AVAILABILITIES_UPDATE: 'availabilities-update',

  // Calendar
  CALENDAR_MANAGE_STATION: 'calendar-manage_station',
  CALENDAR_MANAGEMENT: 'calendar-management',
  CALENDAR_NAVIGATE: 'calendar-navigate',

  // Consultations
  CONSULTATIONS_ACCEPT: 'consultations-accept',
  CONSULTATIONS_ADD_PARTICIPANTS: 'consultations-add_participants',
  CONSULTATIONS_CLOSE: 'consultations-close',
  CONSULTATIONS_COMMENT: 'consultations-comment',
  CONSULTATIONS_CREATE: 'consultations-create',
  CONSULTATIONS_CREATE_WITHOUT_PATIENT: 'consultations-create_without_patient',
  CONSULTATIONS_DIAGNOSE: 'consultations-diagnose',
  CONSULTATIONS_DISPATCH: 'consultations-dispatch',
  CONSULTATIONS_FITNESS_CERTIFICATE: 'consultations-fitness_certificate',
  CONSULTATIONS_LIST: 'consultations-list',
  CONSULTATIONS_MEDICAL_CARE_CERTIFICATE: 'consultations-medical_care_certificate',
  CONSULTATIONS_MEDICAL_CARE_CERTIFICATE_REPORT: 'consultations-medical_care_certificate_report',
  CONSULTATIONS_MSF_ESCALATE: 'consultations-msf_escalate',
  CONSULTATIONS_NO_GO: 'consultations-no_go',
  CONSULTATIONS_NO_GO_REPORT: 'consultations-no_go_report',
  CONSULTATIONS_PDF: 'consultations-pdf',
  CONSULTATIONS_POST_OP: 'consultations-post_op',
  CONSULTATIONS_PRESCRIPTION: 'consultations-prescription',
  CONSULTATIONS_READ: 'consultations-read',
  CONSULTATIONS_REFUSE: 'consultations-refuse',
  CONSULTATIONS_REMINDER: 'consultations-reminder',
  CONSULTATIONS_TODO: 'consultations-todo',
  CONSULTATIONS_UPDATE: 'consultations-update',
  CONSULTATIONS_VALIDATE: 'consultations-validate',
  CONSULTATIONS_TEST: 'consultations-test',

  // Consultation codes
  CONSULTATION_CODES_CREATE: 'consultation-codes-create',
  CONSULTATION_CODES_LIST: 'consultation-codes-list',
  CONSULTATION_CODES_UPDATE: 'consultation-codes-update',

  // Docs
  DOCS_API_READ: 'docs_api-read',
  DOCS_DEV_READ: 'docs_dev-read',

  // Groups
  GROUPS_CREATE_UPDATE: 'groups-create_update',

  // HSEQ
  HSEQ_CREATE: 'hseq-create',
  HSEQ_PDF: 'hseq-pdf',
  HSEQ_READ: 'hseq-read',
  HSEQ_UPDATE: 'hseq-update',

  // Live Locations
  LIVE_LOCATIONS_CREATE: 'live_locations-create',
  LIVE_LOCATIONS_LIST: 'live_locations-list',

  // Locations
  LOCATIONS_CREATE: 'locations-create',
  LOCATIONS_DELETE: 'locations-delete',
  LOCATIONS_LIST: 'locations-list',
  LOCATIONS_UPDATE: 'locations-update',

  // Missions
  MISSIONS_LIST: 'missions-list',
  MISSIONS_READ: 'missions-read',
  MISSIONS_UPDATE: 'missions-update',

  // Notifications
  NOTIFICATIONS_HR: 'notifications-hr',
  NOTIFICATIONS_MSF_MEDCO: 'notifications-msf_medco',
  NOTIFICATIONS_MSF_SLA: 'notifications-msf_sla',

  // Patients
  PATIENTS_ANONYMIZE: 'patients-anonymize',
  PATIENTS_CREATE: 'patients-create',
  PATIENTS_DELETE: 'patients-delete',
  PATIENTS_HISTORY: 'patients-history',
  PATIENTS_LIST: 'patients-list',
  PATIENTS_MEDICAL_RECORD: 'patients-medical_record',
  PATIENTS_READ: 'patients-read',
  PATIENTS_SHARE: 'patients-share',
  PATIENTS_UPDATE: 'patients-update',
  PATIENTS_FILES_CREATE: 'patients-files-create',
  PATIENTS_FILES_DELETE: 'patients-files-delete',
  PATIENTS_FILES_LIST: 'patients-files-list',
  PATIENTS_FILES_READ: 'patients-files-read',

  // Payments
  PAYMENTS_LIST: 'payments-list',

  // Projects
  PROJECTS_LIST: 'projects-list',
  PROJECTS_READ: 'projects-read',
  PROJECTS_UPDATE: 'projects-update',

  // Recordings
  RECORDINGS_LIST: 'recordings-list',
  RECORDINGS_READ: 'recordings-read',

  // Medical References
  MEDICINE_REFERENCE_READ: 'medicine_reference-read',
  MEDICINE_REFERENCE_CREATE: 'medicine_reference-create',
  MEDICINE_REFERENCE_DELETE: 'medicine_reference-delete',

  // Drug References
  DRUG_REFERENCES_SEARCH: 'drug_reference-search',
  DRUG_REFERENCES_CREATE: 'drug_reference-create',
  DRUG_REFERENCES_UPDATE: 'drug_reference-update',
  DRUG_REFERENCES_DELETE: 'drug_reference-delete',
  DRUG_REFERENCES_LIST: 'drug_reference-list',
  DRUG_REFERENCES_READ: 'drug_reference-read',

  // Reports
  REPORTS_CREATE: 'reports-create',
  REPORTS_LIST: 'reports-list',
  REPORTS_READ: 'reports-read',
  REPORTS_FULL_CREATE: 'reports-full-create',
  REPORTS_FULL_LIST: 'reports-full-list',
  REPORTS_FULL_READ: 'reports-full-read',
  REPORTS_PATIENT_CREATE: 'reports-patient-create',
  REPORTS_PATIENT_LIST: 'reports-patient-list',
  REPORTS_PATIENT_READ: 'reports-patient-read',

  // Services
  SERVICES_LIST: 'services-list',

  // Specialists
  SPECIALISTS_LIST: 'specialists-list',
  SPECIALISTS_READ: 'specialists-read',
  SPECIALISTS_UPDATE: 'specialists-update',

  // System
  SYSTEM_ACCESS_ALL: 'access-all',

  // Users
  USERS_LIST: 'users-list',

  // Videoconference
  VIDEOCONFERENCE_ACCESS: 'videoconference',
};
